"use client";
import React, { useEffect } from "react";
import { SparklesCore } from "./ui/sparkles";

export default function LoadingOverlay({ setIsLoading }) {
  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 3000);
    return () => clearTimeout(timer);
  }, [setIsLoading]);

  return (
    <div className="fixed inset-0 bg-black flex flex-col items-center justify-center z-[9999] overflow-hidden px-4">
      {/* Title */}
      <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-bold text-center text-white relative z-20 mb-8">
        SANCHAARA
      </h1>

      {/* Sparkles section */}
      <div className="relative w-full max-w-[70vw] sm:max-w-[24rem] md:max-w-[32rem] lg:max-w-[40rem] h-28 sm:h-36 md:h-40">
        {/* Gradient bars */}
        <div className="absolute inset-x-10 sm:inset-x-20 top-0 bg-gradient-to-r from-transparent via-indigo-500 to-transparent h-[2px] blur-sm" />
        <div className="absolute inset-x-10 sm:inset-x-20 top-0 bg-gradient-to-r from-transparent via-indigo-500 to-transparent h-px" />
        <div className="absolute inset-x-28 sm:inset-x-60 top-0 bg-gradient-to-r from-transparent via-sky-500 to-transparent h-[5px] w-1/3 blur-sm" />
        <div className="absolute inset-x-28 sm:inset-x-60 top-0 bg-gradient-to-r from-transparent via-sky-500 to-transparent h-px w-1/3" />

        {/* Sparkles — show immediately */}
        <SparklesCore
          background="transparent"
          minSize={0.4}
          maxSize={1}
          particleDensity={700} // slightly reduced for phones
          className="w-full h-full"
          particleColor="#FFFFFF"
          instant // not a prop, but we’ll tweak the core below
        />

        {/* Radial mask for smooth fade edges */}
        <div className="absolute inset-0 w-full h-full bg-black [mask-image:radial-gradient(300px_150px_at_top,transparent_20%,white)]"></div>
      </div>
    </div>
  );
}
